import PropTypes from 'prop-types';

const GridIcon = ({toggleColor}) => {
    return (
        <div>
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M5 10.2578H7C9 10.2578 10 9.25781 10 7.25781V5.25781C10 3.25781 9 2.25781 7 2.25781H5C3 2.25781 2 3.25781 2 5.25781V7.25781C2 9.25781 3 10.2578 5 10.2578Z" stroke={toggleColor} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 10.2578H19C21 10.2578 22 9.25781 22 7.25781V5.25781C22 3.25781 21 2.25781 19 2.25781H17C15 2.25781 14 3.25781 14 5.25781V7.25781C14 9.25781 15 10.2578 17 10.2578Z" stroke={toggleColor} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 22.2578H19C21 22.2578 22 21.2578 22 19.2578V17.2578C22 15.2578 21 14.2578 19 14.2578H17C15 14.2578 14 15.2578 14 17.2578V19.2578C14 21.2578 15 22.2578 17 22.2578Z" stroke={toggleColor} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M5 22.2578H7C9 22.2578 10 21.2578 10 19.2578V17.2578C10 15.2578 9 14.2578 7 14.2578H5C3 14.2578 2 15.2578 2 17.2578V19.2578C2 21.2578 3 22.2578 5 22.2578Z" stroke={toggleColor} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </div>
    )
}
GridIcon.propTypes = {
    toggleColor:PropTypes.string
};
export default GridIcon;